import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Overlay } from 'react-bootstrap';
import ui from '../../../common/services/ui';
import { withTranslation } from 'react-i18next';
import globalize from '../../../common/services/globalize';
import moment from 'moment-timezone';
import * as DateRangeLocales from 'react-date-range/dist/locale';
import DateRangePopover, { DateRangePickerMode } from './DateRangePopover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class DateRangePickerButton extends Component {
	constructor(props) {
		super(props);
		this.handleDateRangeToggle = this.handleDateRangeToggle.bind(this);
		this.handlePeriodChange = this.handlePeriodChange.bind(this);
		this.handleTermSelect = this.handleTermSelect.bind(this);
		this.handleYearSelect = this.handleYearSelect.bind(this);
		this.handleModeChange = this.handleModeChange.bind(this);
		this.handleApplySelection = this.handleApplySelection.bind(this);

		this.state = {
			showDateRange: false,
			mode: DateRangePickerMode.PERIOD,
			periodFrom: this.props.periodFrom,
			periodTo: this.props.periodTo,
			term: this.props.term,
			year: this.props.year,
			firstLoad: true
		};
	}

	componentWillReceiveProps(nextProps) {
		const { term, year } = nextProps;

		if (this.state.firstLoad && term && year) { 
			this.setState({
				term,
				year,
				firstLoad: false
			});
		}
	}

	handleDateRangeToggle() {
		this.setState({ showDateRange: !this.state.showDateRange });
	}

	handlePeriodChange(ranges) {
		const { startDate, endDate } = ranges.selection;

		// convert from local time zone to currently selected time zone (configured for moment-timezone) keeping local time
		const startDateInCurrentZone = moment([startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), startDate.getHours(), startDate.getMinutes(), startDate.getSeconds(), startDate.getMilliseconds()]);
		const endDateInCurrentZone = moment([endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), endDate.getHours(), endDate.getMinutes(), endDate.getSeconds(), endDate.getMilliseconds()]);

		this.setState({
			periodFrom: startDateInCurrentZone,
			periodTo: endDateInCurrentZone
		});
	}

	handleTermSelect(term) {
		this.setState({ term });
	}

	handleYearSelect(year) {
		this.setState({ year, term: null });
	}

	handleApplySelection() {
		const { periodFrom, periodTo, term, year } = this.state;
		this.handleDateRangeToggle();
		this.props.onDateRangeSelect({
			periodFrom,
			periodTo,
			term,
			year
		});
	}

	handleModeChange(mode) {
		let newState = {};
		switch (mode) {
			case DateRangePickerMode.PERIOD:
				newState = {
					term: null,
					year: null
				};
				break;
			case DateRangePickerMode.TERM:
				newState = {
					year: this.props.activeYear
				};
				break;
		}
		this.setState({
			mode,
			...newState
		});
	}

	renderButtonTitle() {
		// uses props, will not be updated when current state changes before hitting Apply
		const { periodFrom, periodTo, term, year, terms } = this.props;
		let periodButtonTitle = '';
		if (year || term) {
			if (year) {
				periodButtonTitle = `${year} `;
			}
			if (terms && term) {
				const selectedTerm = terms[term-1];
				periodButtonTitle += selectedTerm ? selectedTerm.name : '';
			}
		} else {
			periodButtonTitle = `${ui.formatDate(periodFrom)} - ${ui.formatDate(periodTo)}`;
		}

		return periodButtonTitle;
	}

	render() {
		const { buttonClassName, currentCulture, t } = this.props;
		const { periodFrom, periodTo, term, year } = this.state;

		const localZone = moment.tz.guess();
		// convert back to local time zone, keeping local time, to display properly on the calendar
		const selectionRange = {
			startDate: periodFrom.clone().tz(localZone, true).toDate(),
			endDate: periodTo.clone().tz(localZone, true).toDate(),
			key: 'selection'
		};

		const dateRangeCulture = currentCulture.replace('-', '');	// en-GB is called enGB in DateRangePicker
		const dateRangeLang = dateRangeCulture.substring(0, 2);
		const dateRangeLocale = DateRangeLocales[dateRangeCulture] || DateRangeLocales[dateRangeLang] || DateRangeLocales['enGB'];

		return <div className='btn-group' style={{ position: 'relative' }}>
			<Button
				ref={button => {
					this.target = button;
				}}
				onClick={this.handleDateRangeToggle}
				className={buttonClassName}
			>
				<FontAwesomeIcon icon={faCalendarDays} /> {this.renderButtonTitle()} <FontAwesomeIcon icon={faChevronDown} />
			</Button>

			<Overlay
				show={this.state.showDateRange}
				onHide={() => this.setState({ showDateRange: false })}
				placement='bottom'
				rootClose
				target={() => ReactDOM.findDOMNode(this.target)}
			>
				<DateRangePopover
					locale={dateRangeLocale}
					buttonClassName={buttonClassName}
					ranges={[selectionRange]} onPeriodChange={this.handlePeriodChange}
					onModeChange={this.handleModeChange} mode={this.state.mode}
					term={term} onTermSelect={this.handleTermSelect}
					year={year} onYearSelect={this.handleYearSelect} t={t}
					onApply={this.handleApplySelection}
					onCancel={this.handleDateRangeToggle}
				/>
			</Overlay>

		</div>;
	}
}

export default withTranslation()(DateRangePickerButton);